module.exports = __webpack_public_path__ + "static/media/api-updates.943127e4.jpg";